import { format, parse } from 'date-fns';

export const convertTime = (time: string) => format(parse(time, 'hh:mm a', new Date()), 'HH:mm');
